import {
	userSagas,
	businessSagas,
	notificationSagas,
	messageSagas,
	packageSagas,
	categorySagas,
	fileSagas,
	servicesSaga,
	couponSaga,
	locationSagas,
	commentSagas,
	ticketSagas,
	financialSagas,
	questionSagas,
	reportsSagas,
	walletPaymentSagas,
	authenticationSagas,
} from 'Ducks';

const rootSagas = [
	...userSagas,
	...businessSagas,
	...notificationSagas,
	...messageSagas,
	...packageSagas,
	...categorySagas,
	...fileSagas,
	...servicesSaga,
	...couponSaga,
	...locationSagas,
	...commentSagas,
	...ticketSagas,
	...financialSagas,
	...questionSagas,
	...reportsSagas,
	...walletPaymentSagas,
	...authenticationSagas,
];

export default rootSagas;
